import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

type Status = 'pending' | 'success' | 'error';

const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { verifyEmail } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState<Status>('pending');
  const [message, setMessage] = useState<string>('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    if (!token) {
      setStatus('error');
      setMessage('This verification link is missing a token.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        await verifyEmail(token);
        if (cancelled) return;
        setStatus('success');
        setTimeout(() => navigate('/dive-in'), 1500);
      } catch (err: any) {
        if (cancelled) return;
        setStatus('error');
        const detail = err?.response?.data?.detail;
        setMessage(
          (typeof detail === 'object' && detail?.message) ||
            (typeof detail === 'string' && detail) ||
            'We could not verify this link. It may have expired.'
        );
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, verifyEmail, navigate]);

  return (
    <div className="app-layout min-h-screen flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center">
        <div className="app-brand" style={{ fontSize: '32px', marginBottom: '16px' }}>
          babylon.markets
        </div>
        <div className="app-card" style={{ padding: '24px' }}>
          {status === 'pending' && (
            <p style={{ color: '#cccccc', fontSize: '14px' }}>Verifying your email...</p>
          )}
          {status === 'success' && (
            <>
              <h2 style={{ color: '#22c55e', fontSize: '20px', marginBottom: '8px' }}>
                Email verified
              </h2>
              <p style={{ color: '#cccccc', fontSize: '14px' }}>
                Redirecting you to the dashboard...
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <h2 style={{ color: '#f44336', fontSize: '20px', marginBottom: '8px' }}>
                Verification failed
              </h2>
              <p style={{ color: '#cccccc', fontSize: '14px' }}>{message}</p>
              <p style={{ marginTop: '20px' }}>
                <Link to="/login" style={{ color: '#2962ff' }}>
                  Sign in
                </Link>{' '}
                <span style={{ color: '#888888' }}>to request a new verification email.</span>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
